import moment from 'moment';

export default {

    methods: {

        setAllDayEndDate(start_date) {
            let startDate = new Date(start_date);
            let endDate = new Date(startDate);
            endDate.setHours(23, 59, 0, 0);

            return this.parseTimeForPicker(endDate);
        },


        formatDateForSearch(date) {
            const parsedDate = moment(date);
            return  parsedDate.format("D MMM YYYY, ddd").toUpperCase();
        },

        formatTimeForSearch(time) {
            const parsedDate = moment(time);
            return  parsedDate.format('h:mm a');
        },
        getTimeForTimeSlots(isoTimeString) {
            const parsedTime = moment(isoTimeString)
            return parsedTime.format('hh:mm a')
        },

        getSlotTimeLimit(time) {
            const calcTime = moment().add(time, 'hours')
            return calcTime.valueOf();
        },

        getTimeForBooking(time) {
            const parsedTime = moment(time)
            return parsedTime.format('YYYY-MM-DD HH:mm:ss')
        },

        formatTimeStamp(day, time) {
            const dateTimeString = `${day} ${time}`;
            const parsedDate = moment(dateTimeString, 'MM-DD-YYYY hh:mm a');
            return parsedDate.format('YYYY-MM-DD[T]HH:mm:ss');
        },
        parseTimeForEvent(dateString) {
            const moment = require('moment');
            const parsedDate = moment(dateString, 'MM-DD-YYYY hh:mm a');
            return parsedDate.format('YYYY-MM-DD[T]HH:mm:ss');
        },
        formatDateTimeRangeForAllDay(startDate, endDate) {
            const options = {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
            };

            const start = new Date(startDate);
            const end = new Date(endDate);

            const formattedStartDate = start.toLocaleDateString('en-US', options);
            const formattedEndDate = end.toLocaleDateString('en-US', options);

            return `${formattedStartDate} - ${formattedEndDate}`;
        },

        formatDateTimeRange(startDate, endDate) {
            const options = {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            };

            const start = new Date(startDate);
            const end = new Date(endDate);

            const formattedStartDate = start.toLocaleDateString('en-US', options);
            const formattedEndDate = end.toLocaleDateString('en-US', options);

            return `${formattedStartDate} - ${formattedEndDate}`;
        },


        getDayOfWeek(type) {
            if (type === 'short') {
                return moment().format('ddd');
            } else {
                return moment().format('dddd');
            }
        },



        parseTimeForPicker(dateString) {
            const date = new Date(dateString);

            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const year = date.getFullYear();
            let hours = date.getHours();
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const ampm = hours >= 12 ? 'pm' : 'am';

            if (hours === 0) {
                hours = 12;
            } else if (hours > 12) {
                hours -= 12;
            }

            return `${month}-${day}-${year} ${hours}:${minutes} ${ampm}`;

        },

        getMilliseconds(time) {
            return time * 60 * 60 * 1000
        },

        getDayToday() {
            return moment().format("MM/DD/YYYY")
        },

        calculateDate(dateString) {
            const parsedDate = moment(dateString);
            return parsedDate.format('MM-DD-YYYY');
        },

        getDayForTimeSlot() {
            return moment().format("MM-DD-YYYY")
        },

        getDayKey(date) {
            return moment(date).format('YYYY_MM_DD');
        },

        formatDate(dateString) {
            const date = new Date(dateString);

            const months = [
                'January', 'February', 'March', 'April',
                'May', 'June', 'July', 'August',
                'September', 'October', 'November', 'December'
            ];

            const year = date.getFullYear();
            const month = months[date.getMonth()];
            const day = date.getDate();
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const seconds = date.getSeconds();
            const period = hours >= 12 ? 'PM' : 'AM';
            const displayHours = hours % 12 || 12;
            const formattedDate = `${month}-${day}-${year} | ${displayHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${period}`;

            return formattedDate;
        },

        dateForTimeSheets(dateString) {

            const months = [
                'January', 'February', 'March', 'April',
                'May', 'June', 'July', 'August',
                'September', 'October', 'November', 'December'
            ];

            const date = new Date(dateString);

            const year = date.getFullYear();
            const month = months[date.getMonth()];
            const day = date.getDate().toString().padStart(2, '0');

            return `${month} ${day}, ${year}`;
        },

        calculateDateSlash(dateString) {

            const date = new Date(dateString);

            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');

            return `${month}/${day}/${year}`;
        },

        getDateNow() {
            let currentDate = new Date();
            let year = currentDate.getFullYear();
            let month = currentDate.getMonth() + 1;
            let day = currentDate.getDate();

            return month + "-" + day + "-" + year;
        },
        calcExpirationDate(date) {
            const selectedDate = new Date(date);
            const today = new Date();
            const diff = selectedDate.getTime() - today.getTime()
            const expDays = (diff / 86400000).toFixed()

            if (expDays <= 30 && expDays > 0) {
                return 'color--orange'
            } else if (expDays <= 0) {
                return 'color--red'
            } else {
                return 'color--green'
            }
        },
        formatTime(time) {
            const hours = Math.floor(time / (1000 * 60 * 60));
            time -= hours * (1000 * 60 * 60);
            const minutes = Math.floor(time / (1000 * 60));
            return `${hours} h ${minutes} m`
        },

        calculateDeadlineForTimesheet(date) {
            const originalDate = new Date(date);
            originalDate.setDate(originalDate.getDate() + 1);
            let newDate = originalDate.toISOString().slice(0, 10);
            return this.dateForTimeSheets(newDate);

        }
    }
}
